import React from 'react';

type Props = {
  classes?: string;
};

const LiveIndicator = ({ classes = '' }: Props) => {
  return (
    <div
      className={`${classes} tw-animate-blink tw-rounded-full tw-w-[14px] tw-h-[14px] tw-bg-gradient-to-r tw-from-[#ff6000] tw-via-[#ff2e4d] tw-via-[#ff2e56] tw-via-[#ff2f84] tw-to-[#ff2f96]`}
    ></div>
  );
};

export default LiveIndicator;
